import ENV from '../../config/environment';
import main from './main';

export default function (server) {
  main(server);

  const { MIRAGE_LOCATIONS } = ENV;
  const locationIds = MIRAGE_LOCATIONS ? MIRAGE_LOCATIONS.split(',') : server.schema.locations.all().models.mapBy('id');

  for (let i = 0; i < locationIds.length; i++) {
    const locationId = locationIds[i];

    server.create('ui-hook', 'asBadgeBarcode', {
      locationId,
      uiHookId: `sim-${locationId}-d44c-441d-8db2-ba5c4bc04a35`,
    });
    server.create('ui-hook', 'asBadgeBarcode', {
      locationId,
      label: 'Access',
      icon: '/assets/images/app-icons/visitors.svg',
      uiHookId: `sim-${locationId}-56d9-4b79-b754-55a6700c50c4`,
    });
    server.create('ui-hook', 'asBadgeBarcode', {
      locationId,
      label: 'Cafeteria Dining Credit: Lunch and Dinner',
      icon: '/assets/images/features/integration.svg',
      uiHookId: `sim-${locationId}-4166-4119-9cd4-264e5d571b31`,
    });

    server.create('ui-hook', 'asBadgeQrCode', {
      locationId,
      uiHookId: `sim-${locationId}-a659-4c76-89ef-339a35c978ed`,
    });
    server.create('ui-hook', 'asBadgeQrCode', {
      locationId,
      label: 'Passport',
      icon: '/assets/images/passport.svg',
      uiHookId: `sim-${locationId}-a4c2-4a32-b03f-cd364f27e2fb`,
    });
    server.create('ui-hook', 'asBadgeQrCode', {
      locationId,
      label: 'Personalized WiFi Access Instructions URL',
      icon: '/assets/images/app-icons/visitors.svg',
      uiHookId: `sim-${locationId}-60d8-49a7-a5fd-8e84f594e590`,
    });
    server.create('ui-hook', 'asBadgeQrCode', {
      locationId,
      label: 'Cafeteria Dining Credit: Lunch and Dinner',
      icon: '/assets/images/features/integration.svg',
      uiHookId: `sim-${locationId}-da13-4d41-a787-82b64cfb9b3a`,
    });
  }
}
